export const CONTENT_TABLE_WRAPPER_CLASS = 'Content__tableScroll';

const CONTENT_SELECTOR = '.Content';
const BLOCK_TABLE_SELECTOR = '.wp-block-table';
const WRAPPER_SELECTOR = `.${CONTENT_TABLE_WRAPPER_CLASS}`;

export function shouldWrapContentTable(table) {
    if (!table || typeof table.closest !== 'function') {
        return false;
    }

    return Boolean(table.closest(CONTENT_SELECTOR)) && !table.closest(BLOCK_TABLE_SELECTOR) && !table.closest(WRAPPER_SELECTOR);
}

export function wrapContentTable(table) {
    if (!shouldWrapContentTable(table) || !table.parentNode) {
        return null;
    }

    const wrapper = document.createElement('div');
    wrapper.className = CONTENT_TABLE_WRAPPER_CLASS;
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);

    return wrapper;
}

export function initResponsiveContentTables(root = document) {
    root.querySelectorAll(`${CONTENT_SELECTOR} table`).forEach(wrapContentTable);
}

if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initResponsiveContentTables());
    } else {
        initResponsiveContentTables();
    }
}
